module.exports = __webpack_public_path__ + "fonts/helveticaneueltpro-roman-webfont.577c7dc0.woff";